module.exports = __webpack_public_path__ + "static/media/logo.5a6c0526.svg";